import { render } from "./SessionExpiredModal.vue?vue&type=template&id=3459f2b7&scoped=true&lang=pug"
import script from "./SessionExpiredModal.vue?vue&type=script&lang=js"
export * from "./SessionExpiredModal.vue?vue&type=script&lang=js"

import "./SessionExpiredModal.vue?vue&type=style&index=0&id=3459f2b7&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3459f2b7"]])

export default __exports__